import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { Contact } from "@/types/contacts";

interface ContactStateChartProps {
  contacts: Contact[];
}

export const ContactStateChart = ({ contacts }: ContactStateChartProps) => {
  const stateCounts = contacts.reduce((acc, contact) => {
    const state = contact.state || 'Outros';
    acc[state] = (acc[state] || 0) + 1;
    return acc;
  }, {} as Record<string, number>);

  const data = Object.entries(stateCounts)
    .map(([state, count]) => ({
      state,
      count
    }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 10);

  return (
    <Card className="border-border/50">
      <CardHeader>
        <CardTitle className="text-foreground">Top 10 Estados</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
            <XAxis 
              dataKey="state" 
              stroke="hsl(var(--muted-foreground))"
              style={{ fontSize: '12px' }}
            />
            <YAxis stroke="hsl(var(--muted-foreground))" />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px'
              }}
            />
            <Legend />
            <Bar 
              dataKey="count" 
              fill="hsl(var(--chart-1))" 
              name="Quantidade"
              radius={[8, 8, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
